import { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { withRouter } from "react-router";
import { Badge, BlockStack, Button, Card, IndexFilters, IndexTable, Modal, Page, Popover, ProgressBar, Text, TextField, Icon, Tooltip, useIndexResourceState, Pagination, Spinner } from "@shopify/polaris";
import Langauge from "../../../i18n/Language";
import {
    AdjustIcon,
    XIcon,
    ChevronDownIcon,
    DeleteIcon,
    EditIcon,
    QuestionCircleIcon,
    RefreshIcon,
    SearchIcon,
    MagicIcon,
} from "@shopify/polaris-icons";
import AIOutputStream from "./components/AIOutputStream";
import Countrys from '../../../utils/country';
import {
    reqGetTopicClusterList,
    reqUpdateTopicCluster,
    reqDeleteTopicCluster,
    reqGenerateTopicCluster,
    reqGetTopicClusterRecord,
    reqHandleAIUsagePayment,
    reqGetKeywordSearch,
    reqGetAnalyzeBusiness,
    reqUpdAnalyzeBusiness,
    reqTriggerAiAnalyzeBusiness,
    reqGetRecommendKeywords,
    reqGetWebsiteSyncStatus,
    reqDelRecommendKeywords,

} from "../../../api/index";
import FooterPageSelect from "../../../components/FooterPageSelect/indexPage";
import { cloneDeep, debounce } from "lodash-es";
import BannerMsgMoudle from "../../../components/BannerMsgMoudle";
import { store } from "../../../redux/store";
import FooterTrustHelp from "../../../components/FooterTrustHelp";
import "./index.scss";
import TagTextInput from "../NewUserGuide/components/TagTextInput";
import { AiLanguageArr } from "../../../utils/LanguageList";
import { eventBus, KeywordPlanner_CLICK } from '../../../eventBus';
import SkeltonLoading from "../../../components/SkeltonLoading";
import { setPageData } from "../../../redux/actions/getAppPageData";
import { showNewMessage } from "@intercom/messenger-js-sdk";
const t = Langauge;

let recordArr = [];
let AnalysisStatusArr = [];
let fakeTimers = [];
// 假进度
const fakeSteps = [
    { delay: 1000, value: 5 },
    { delay: 10000, value: 35 },
    { delay: 20000, value: 65 },
];

const KeywordContentPlaner = (props) => {
    const {
        level,

        toggleToast,
        openUpdateLimit,
    } = props;

    const topicDataRef = useRef(null);
    const recordDataRef = useRef(null);
    const recKeywordDataRef = useRef(null);
    const analyzeBusinessDataRef = useRef(null);
    const pageRef = useRef(1);
    const sizeRef = useRef(10);
    const aiStepSettingRef = useRef({});
    const timeoutsRef = useRef([]);
    const animationFrameRef = useRef(null);
    const isJumpRef = useRef(true);
    const prevTopicIdRef = useRef(-1);
    const gStepRef = useRef(0);
    const isStartGenerateRef = useRef(false);
    const moreRecordRef = useRef(0);
    const countrySelRef = useRef({});
    const languageValueRef = useRef("en");
    const progressAiOpenRef = useRef(false);
    const listeningRef = useRef(false);
    const seedKeywordRef = useRef("");
    const isResetAllRef = useRef(false);

    const stepTipArr = [
        {
            id: 1,
            desc: "Enter a seed keyword related to your business.",
            img: "/imgs/ai/planner_step1.png",
        },
        {
            id: 2,
            desc: "We'll clustered all high-potential keywords and build a topical map.",
            img: "/imgs/ai/planner_step2.png",
        },
        {
            id: 3,
            desc: "Pick your winning topics, generate blogs post, and grow your traffic.",
            img: "/imgs/ai/planner_step3.png",
        }
    ]

    const newLangArr = AiLanguageArr;                                                                                    // 新翻译语言
    const [loadingRecord, setLoadingRecord] = useState(true); // 加载状态
    const [loadingRecKeyword, setLoadingRecKeyword] = useState(true); // 加载状态
    const [seedKeyword, setSeedKeyword] = useState(""); // 关键词
    const [aiPoints, setAiPoints] = useState({}); // ai额度
    const [aiUsageStatus, setAiUsageStatus] = useState(-1); // ai使用状态
    const [aiUse, setAiUse] = useState(0); // ai使用额度
    const [aiAll, setAiAll] = useState(10); // ai额度
    const [isShowAiProgress, setIsShowAiProgress] = useState(false); // 是否显示ai进度
    const [selected, setSelected] = useState(0); // 选中
    const [queryValue, setQueryValue] = useState(""); // 查询值
    const [sortSelected, setSortSelected] = useState(["data asc"]); // 排序
    const [mode, setMode] = useState("DEFAULT"); // DEFAULT || FILTERING 
    const [delTipState, setDelTipState] = useState(false); // 删除提示
    const [gStep, setGStep] = useState(0);  // 生成步骤
    const [startGFirst, setStartGFirst] = useState(0);  // 生成步骤1进度
    const [startGSec, setStartGSec] = useState(0);  // 生成步骤2进度
    const [startGThird, setStartGThird] = useState(0);  // 生成步骤3进度
    const [startGFourth, setStartGFourth] = useState(0);  // 生成步骤4进度
    const [countryValue, setCountryValue] = useState('');                                                   // 国家搜索val 
    const [nationState, setNationState] = useState(false);                                                     // 国家val 
    const [countryAll, setCountryAll] = useState({});                                                       // 国家总数据
    const [currents, setCurrents] = useState({});                                                           // 国家对象
    const [countryView, setCountryView] = useState([]);                                                     // 国家列表 
    const [countryLens, setCountryLens] = useState(0);                                                      // 国家长度
    const [cpage, setCpage] = useState(1);                                                                  // 国家页码
    const [csize, setCsize] = useState(20);                                                                 // 国家页数
    const [isStartGenerate, setIsStartGenerate] = useState(false); // 是否开始生成
    const [seedKeywordError, setSeedKeywordError] = useState(""); // 关键词错误提示
    const [delBtnLoading, setDelBtnLoading] = useState(false); // 删除按钮loading
    const [operaId, setOperaId] = useState(-1); // 操作id
    const [editPlanId, setEditPlanId] = useState(-1); // 编辑id
    const [topicNameValue, setTopicNameValue] = useState(""); // 编辑输入框内容
    const [saveTopicNameLoading, setSaveTopicNameLoading] = useState(false); // 保存输入框内容loading
    const [generateLoading, setGenerateLoading] = useState(false); // 生成loading
    const [languageState, setLanguageState] = useState(false); // 语言状态
    const [languageLabel, setLanguageLabel] = useState("English"); // 语言值
    const [languageValue, setLanguageValue] = useState("en"); // 语言值
    const [messageInfo, setMessageInfo] = useState({}); // 提示信息
    const [stepData, setStepData] = useState({}); // 步骤数据
    const [agreeLoading, setAgreeLoading] = useState(false); // 同意loading
    const [buyAiCreditsState, setBuyAiCreditsState] = useState(false); // 超额状态
    const [userLevel, setUserLevel] = useState(1); // 用户等级
    const [keywordSearchLoading, setKeywordSearchLoading] = useState(false); // 关键词搜索loading
    const [isShowAdjustPop, setIsShowAdjustPop] = useState(false); // 是否显示调整弹窗
    const [seekIn, setSeekIn] = useState(false); // 是否聚焦搜索
    const [seedFocusedState, setSeedFocusedState] = useState(false); // 关键词聚焦状态
    const [isShowAudienceLocal, setIsShowAudienceLocal] = useState(false); // 是否显示受众本地弹窗
    const [businessInfoSetState, setBusinessInfoSetState] = useState(false); // 企业信息配置弹窗
    const [brandNameValue, setBrandNameValue] = useState(""); // 品牌名称值
    const [recommendKeywordsList, setRecommendKeywordsList] = useState([]); // 推荐关键词列表
    const [removeLoadingId, setRemoveLoadingId] = useState(-1); // 移除loading id
    const [rpage, setRpage] = useState(1);
    const [rsize, setRsize] = useState(4);
    const [rtotal, setRtotal] = useState(0);
    const [PrimaryProduct, setPrimaryProduct] = useState([]); // 主要产品
    const [KeyProductAttributes, setKeyProductAttributes] = useState([]); // 关键产品属性
    const [TargetPersona, setTargetPersona] = useState([]); // 目标人群
    const [abusinLoading, setAbusinLoading] = useState(true); // 业务信息loading
    const [isShowSteps, setIsShowSteps] = useState(false); // 是否显示步骤
    const [stepsStorageState, setStepsStorageState] = useState(true); // 步骤存储状态
    const [existBusiness, setExistBusiness] = useState(false); // 是否存在业务信息
    const [originBusinessData, setOriginBusinessData] = useState({}); // 原始业务数据
    const [aiAnalysisStatus, setAiAnalysisStatus] = useState(0); // ai分析状态
    const [aiKeywordStatus, setAiKeywordStatus] = useState(0); // ai关键词状态
    const [saveBusinessInfoLoading, setSaveBusinessInfoLoading] = useState(false); // 保存业务信息loading
    const [isShowClickTip, setIsShowClickTip] = useState(false); // 是否显示点击提示
    const [allRecommendKeywordsList, setAllRecommendKeywordsList] = useState([]); // 所有推荐关键词列表
    const [hasNextChange, setHasNextChange] = useState(false); // 是否有下一页
    const [completedVal, setCompletedVal] = useState(0); // 完成进度
    const [manualAnalyzeLoading, setManualAnalyzeLoading] = useState(false); // 手动分析loading
    const [onlySimply, setOnlySimply] = useState(false); // 是否只有简单模式
    const [queryValueGet, setQueryValueGet] = useState(""); // 查询值
    const [reduxLoading, setReduxLoading] = useState(true); // 缓存loading
    const [isResetAll, setIsResetAll] = useState(false); // 是否重置
    const [errorState, setErrorState] = useState(false); // 错误状态

    // 分页数据
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(10);
    const [current_PageSize, setCurrentPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [hasPrevious, setHasPrevious] = useState(false);
    const [hasNext, setHasNext] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [loadingPage, setLoadingPage] = useState(true);
    const [openVideo, setOpenVideo] = useState(false); // 视频弹窗
    const [tableLoading, setTableLoading] = useState(false); // 表格loading

    // 关键词提示
    const [keywordSugPop, setKeywordSugPop] = useState(false);
    const [keywordSugData, setKeywordSugData] = useState([
        {
            keyword: "Keyword",
            competition: "Competition",
            volume: "Volume",
        }
    ]);
    const [customSeedKeywordState, setCustomSeedKeywordState] = useState(false); // 自定义主题

    const { selectedResources, allResourcesSelected, handleSelectionChange, clearSelection } =
        useIndexResourceState(tableData);


    // 设置提示banner
    const setTipBanner = (msg, tone = 'critical') => {
        setMessageInfo({ msg, tone });
    }

    // 跳转对应步骤
    const handleSetStepAction = (data) => {
        let _cstep = data[4]?.status === 1 ? 4 : data[3]?.status === 1 ? 3 : data[2]?.status === 1 ? 2 : 1;
        _cstep = (moreRecordRef.current === 1 && gStepRef.current <= 1) ? 1 : _cstep;
        gStepRef.current = _cstep;
        setGStep(_cstep);
        if (data[1]?.status === 1) {
            setIsStartGenerate(true);
            isStartGenerateRef.current = true;
        }
        if (_cstep >= 2) {
            setStartGFirst(100);
            if (_cstep >= 3) {
                setStartGSec(100);
                if (_cstep >= 4) {
                    setStartGThird(100);
                    if (data[4]?.status === 1) {
                        setStartGFourth(100);
                    }
                }
            }
        }

        moreRecordRef.current = 1;
    }

    // 关键词搜索
    const handleKeywordSearch = async (value) => {
        let params = {
            keyword: value,
            location_id: countrySelRef.current.id || 2840,
            language: languageValueRef.current || "en",
        }
        const res = await reqGetKeywordSearch(params);
        let formatData = []
        if (res.ack === 1) {
            formatData = (res.data.slice(0, 5)).map(item => {
                return {
                    keyword: item.keyword,
                    competition: item.competition,
                    volume: item.volume,
                }
            })
            formatData.unshift({
                keyword: "Keyword",
                competition: "Competition",
                volume: "Volume",
            })
            setKeywordSugData(formatData);
        } else {
            setTipBanner(res.msg);
            setKeywordSugPop(false);
        }

        setKeywordSearchLoading(false);
    }
    const debouncedKeywordSearch = useMemo(() => debounce((value) => {
        if (value) {
            handleKeywordSearch(value);
        } else {
            setKeywordSugPop(false);
        }
    }, 1000), [handleKeywordSearch]); // 300ms 可根据需求调整

    // 获取生成记录
    const getRecordData = async (isUpdate = false) => {
        const res = recordDataRef.current || (await reqGetTopicClusterRecord());
        if (res.ack === 1) {
            setLoadingRecord(false);
            let _quota = res.data.ai_points;
            setIsShowSteps(res.data.is_new_user);
            setAiUsageStatus(res.data.ai_usage_status);
            setAiPoints(_quota);
            setAiUse(_quota.ai_points_gift_use + _quota.ai_points_paid_use);
            setAiAll(_quota.ai_points_gift_all + _quota.ai_points_paid_all);
            let isOpenMore = typeof res.data.ai_usage_status === "boolean" && Boolean(res.data.ai_usage_status);
            setIsShowAiProgress(!isOpenMore && (_quota.ai_points_gift_all - _quota.ai_points_gift_use) <= 20 && (_quota.ai_points_paid_all - _quota.ai_points_paid_use) <= 20);
            setStepData(res.data.step);
            aiStepSettingRef.current = res.data.step;
            setQueryValueGet(queryValue);
            // 判断ai生成轮询
            if (!Boolean(res.data.status)) {
                if (recordArr.length === 0) {
                    let timer = setInterval(() => {
                        getRecordData();
                    }, 3000);
                    recordArr.push(timer);
                }
                // 跳转对应步骤
                if (gStepRef.current <= 1 && !(isStartGenerateRef.current)) {
                    handleSetStepAction(res.data.step);
                }
                // 设置关键词
                seedKeywordRef.current = res.data.keyword;
                setSeedKeyword(res.data.keyword);
            } else {
                prevTopicIdRef.current = res.data.topic_cluster_id;
                clearRecordTimer();
                setAgreeLoading(false);
            }

            // 错误状态
            if (Boolean(res.data.status === 2)) {
                getListData(pageRef.current, sizeRef.current, queryValue);
                setErrorState(true);
                setStepData({});
                aiStepSettingRef.current = {};
            }

            // 自动生成
            if (isUpdate && !progressAiOpenRef.current) {
                progressAiOpenRef.current = false;
                handleGenerate({
                    new: true,
                    aiPoints: _quota,
                    aiUsageStatus: res.data.ai_usage_status,
                });
            }

            // 设置缓存
            if (recordDataRef.current) {
                recordDataRef.current = null;
                getRecordData(isUpdate);
            } else {
                store.dispatch(setPageData(['KeywordContentPlanner', { 'recordData': res }]));
            }
        } else {
            setTipBanner(res.msg);
        }
    }

    // 获取业务数据
    const getAnalyzeBusinessData = async () => {
        const res = analyzeBusinessDataRef.current || (await reqGetAnalyzeBusiness());
        if (res.ack === 1) {
            const _t = res.data;
            setAbusinLoading(false);
            setBrandNameValue(_t.brand_name);
            setPrimaryProduct(_t.primary_products);
            setKeyProductAttributes(_t.key_attributes);
            setTargetPersona(_t.target_audience);
            setAiAnalysisStatus(_t.ai_analysis);
            setAiKeywordStatus(_t.ai_keyword);
            setOriginBusinessData(_t);
            setReduxLoading(Boolean(analyzeBusinessDataRef.current));
            // 设置默认数据
            let localCountry = Countrys.find(i => i.abb === _t.audience_location) || Countrys[0];
            selectCountryData(localCountry);
            countrySelRef.current = localCountry;
            let _label = AiLanguageArr.find(i => i.value === _t.content_language)?.label || "English";
            setLanguageValue(_t.content_language || 'en');
            setLanguageLabel(_label);
            languageValueRef.current = _t.content_language || 'en';

            // 判断是否存在业务信息
            let existBusiness = Boolean(_t.primary_products?.length > 0 || _t.key_attributes?.length > 0 || _t.target_audience?.length > 0);
            setExistBusiness(existBusiness);
            let _store = store.getState().public.publicInit?.head_data?.switch_data;
            let isHasGuide = store.getState().public.publicInit?.guide_steps?.length > 0;
            let inBusiness = typeof _store === 'boolean' ? true : (!Boolean(_store?.in_business) && _t.ai_analysis === 2 && _t.ai_keyword === 0 && isHasGuide);
            setIsShowAdjustPop(inBusiness);
            // 判断轮询 - 业务信息
            if (_t.ai_analysis === 1 || _t.ai_keyword === 1) {
                let type = _t.ai_analysis === 1 ? 1 : 2;
                getWebsiteSyncStatus(type);
            }
            // 判断是否有推荐关键词
            if (_t.ai_keyword === 2) {
                getRecommendKeywordsList();
            } else {
                setLoadingRecKeyword(false);
            }

            // 设置缓存
            if (analyzeBusinessDataRef.current) {
                analyzeBusinessDataRef.current = null;
                getAnalyzeBusinessData();
            } else {
                store.dispatch(setPageData(['KeywordContentPlanner', { 'analyzeBusinessData': res }]));
            }
        }
    }

    // 获取推荐关键词列表
    const getRecommendKeywordsList = async () => {
        const params = {
            type: "content_plan",
        }
        const res = recKeywordDataRef.current || (await reqGetRecommendKeywords(params));
        if (res.ack === 1) {
            let _t = res.data;
            let _data = _t.slice((rpage - 1) * rsize, rpage * rsize);
            setAllRecommendKeywordsList(_t);
            setRecommendKeywordsList(_data);
            setHasNextChange(_t.length > rsize);
            setRtotal(_t.length);
            setLoadingRecKeyword(false);

            // 设置缓存
            if (recKeywordDataRef.current) {
                recKeywordDataRef.current = null;
                getRecommendKeywordsList();
            } else {
                store.dispatch(setPageData(['KeywordContentPlanner', { 'recKeywordData': res }]));
            }
        }
    }

    // 清除轮询
    const clearRecordTimer = () => {
        recordArr.map(timer => {
            clearInterval(timer);
            recordArr.pop();
            return false;
        })
    }

    // 获取列表数据
    const getListData = async (page, size, query) => {
        setTableLoading(true);
        let params = {
            page,
            size,
            query,
        }
        const res = topicDataRef.current || (await reqGetTopicClusterList(params));
        if (res.ack === 1) {
            setTableLoading(false);
            setTableData(res.data.list);
            setTotal(res.data.count);
            // 计算是否有上下页
            setHasPrevious(page > 1);
            setHasNext((page * size) < res.data.count);
            let isSimply = Boolean(res.data.list && res.data.list.length === 1 && res.data.list[0]?.type === 1);
            setOnlySimply(isSimply);

            // 设置缓存
            if (topicDataRef.current) {
                topicDataRef.current = null;
                getListData(page, size, query);
            } else {
                store.dispatch(setPageData(['KeywordContentPlanner', { 'topicData': res }]));
            }
        }

        setLoadingPage(false);
    }
    const debouncedGetListData = useMemo(() => debounce((value) => {
        getListData(1, 10, value);
    }, 500), [getListData]); // 300ms 可根据需求调整

    // 搜索
    const handleFiltersQueryChange = useCallback((value) => {
        value && setQueryValueGet(value);
        setQueryValue(value);
        pageRef.current = 1;
        sizeRef.current = 10;
        setPage(1);
        setSize(10);
        setCurrentPageSize(10);
        debouncedGetListData(value);
    }, []);

    // 清除过滤条件
    const handleFiltersClearAll = useCallback(() => {
        handleFiltersQueryChange("");
    }, [handleFiltersQueryChange]);

    const onCreateNewView = async (value) => {
        return value;
    };

    // 取消
    const onHandleCancel = () => {
        if (queryValue) {
            handleFiltersClearAll();
        }
    };

    // 删除提示
    const handleOpenDelTip = (id) => {
        setDelTipState(true);
        if (id !== -1) {
            setOperaId([id]);
        } else {
            setOperaId(selectedResources);
        }
    }

    // 安全设置定时器
    const safeSetTimeout = (fn, delay) => {
        const timeoutId = setTimeout(fn, delay);
        timeoutsRef.current.push(timeoutId);
        return timeoutId;
    };
    const clearAllTimers = () => {
        timeoutsRef.current.forEach(clearTimeout);
        timeoutsRef.current = [];
        if (animationFrameRef.current) {
            cancelAnimationFrame(animationFrameRef.current);
            animationFrameRef.current = null;
        }
    };

    // 动画结束
    const pollUntilStatusReady = (stepIndex, callback, retryFn) => {
        const aiStepSetting = aiStepSettingRef.current;
        if (aiStepSetting[stepIndex]?.status === 1) {
            callback();
        } else {
            safeSetTimeout(retryFn, 1000);
        }
    };

    // 生成结束
    const onEndAi = (id) => {
        if (isResetAll || isResetAllRef.current) {
            return false;
        }
        switch (id) {
            case 'gstep_first_box':
                pollUntilStatusReady(2, () => handleSetGStepOpera(1), () => onEndAi(id));
                break;
            case 'gstep_sec_box':
                pollUntilStatusReady(3, () => handleSetGStepOpera(2), () => onEndAi(id));
                break;
            case 'gstep_third_box':
                pollUntilStatusReady(4, () => handleSetGStepOpera(3), () => onEndAi(id));
                break;
            case 'gstep_fourth_box':
                pollUntilStatusReady(4, () => handleSetGStepOpera(4), () => onEndAi(id));
                break;
            default:
                break;
        }

    }

    // 生成步骤 动画
    const handleSetGStepOpera = (step = 1) => {
        // 判断是否重置
        if (isResetAll || isResetAllRef.current) {
            return false;
        }
        switch (step) {
            case 1:
                setStartGFirst(100);
                setIsStartGenerate(true);
                safeSetTimeout(() => {
                    setStepParams(2, 'setStartGSec');
                }, 4000);
                break;
            case 2:
                safeSetTimeout(() => {
                    setStepParams(3, 'setStartGThird');

                }, 4000);
                break;
            case 3:
                safeSetTimeout(() => {
                    setStepParams(4, 'setStartGFourth');
                }, 4000);
                break;
            case 4:
                // 获取最新数据跳转详情
                toggleToast(t("Generation completed"));
                if (prevTopicIdRef.current !== -1 && isJumpRef.current) {
                    // 判断是否回调获取首页
                    if (onlySimply) {
                        props.callbackGetHome();
                    }

                    setTimeout(() => {
                        handleJumpPlannerDetail(prevTopicIdRef.current, 0);
                    }, 1500);
                }
                break;
            default:
                break;
        }
    }

    // 设置步骤参数
    const setStepParams = (step, type = '') => {
        // 判断是否重置
        if (isResetAll || isResetAllRef.current) {
            return false;
        }
        gStepRef.current = step;
        setGStep(step);
        switch (type) {
            case 'setStartGSec':
                setStartGSec(100);
                break;
            case 'setStartGThird':
                setStartGThird(100);
                break;
            case 'setStartGFourth':
                setStartGFourth(100);
                break;
            default:
                break;
        }
    }

    // 输入框内容
    const handleInputChange = (val, type) => {
        switch (type) {
            case "countryValue":
                setCountryValue(val);
                changeCountryData(val);
                break;
            default:
                break;
        }
    }

    // 选择国家
    const togglePopSelect = (type) => {
        if (type === "nationState") {
            setNationState(!nationState);
            resetCountryData();
        } else if (type === "languageState") {
            setLanguageState(!languageState);
        }
    }

    // 重置数据
    const resetCountryData = () => {
        if (nationState) {
            let oData = countryAll.slice(0, 20);
            let lens = countryAll.length;
            setCpage(1);
            setCsize(20);
            setCountryValue('');
            setCountryView(oData);
            setCountryLens(lens);
        }
    }

    // 选中国家
    const selectCountryData = (data) => {
        setCurrents(data);
        countrySelRef.current = data;
        setNationState(false);
        resetCountryData();
    }

    // 获取更多国家
    const getMoreCountry = () => {
        if (countryValue) {
            let searchVal = countryValue.toLowerCase();
            let newData = countryAll.filter(item => (item.abb.toLowerCase()).indexOf(searchVal) > -1 || (item.name.toLowerCase()).indexOf(searchVal) > -1);
            let firstArr = [];
            let lastArr = [];
            newData.forEach(item => {
                if ((item.name.toLowerCase()).indexOf(searchVal) === 0) {
                    firstArr.push(item);
                } else {
                    lastArr.push(item);
                }
            })
            newData = [...firstArr, ...lastArr];
            setCountryView(newData.slice(0, (cpage + 1) * csize));
            setCountryLens(newData.length);
            setCpage(cpage + 1);
        } else {
            setCountryView(countryAll.slice(0, (cpage + 1) * csize));
            setCpage(cpage + 1);
        }

    }

    // 国家数据格式化
    const changeCountryData = (val) => {
        let searchVal = val.toLowerCase();
        let newData = countryAll.filter(item => (item.abb.toLowerCase()).indexOf(searchVal) > -1 || (item.name.toLowerCase()).indexOf(searchVal) > -1);
        let firstArr = [];
        let lastArr = [];
        newData.forEach(item => {
            if ((item.name.toLowerCase()).indexOf(searchVal) === 0) {
                firstArr.push(item);
            } else {
                lastArr.push(item);
            }
        })
        newData = [...firstArr, ...lastArr];
        setCountryView(newData.slice(0, 20));
        setCountryLens(newData.length);
        setCpage(1);
        setCsize(20);
    }

    // 选择语言
    const selectLanguageData = (data) => {
        setLanguageValue(data.value); // 语言值
        setLanguageLabel(data.label);
        setLanguageState(false);
        languageValueRef.current = data.value;
    }

    // 购买积分提示
    const handleBuyAiCreditsState = (_state) => {
        setBuyAiCreditsState(_state);
    }

    // 生成
    const handleGenerate = async (newSet = {}) => {
        setErrorState(false);
        setIsResetAll(false);
        isResetAllRef.current = false;
        // 判断是否有值
        let _seedKeyword = seedKeywordRef.current || seedKeyword;
        if (!_seedKeyword || seedKeywordError) {
            return;
        } else {
            setKeywordSugPop(false);
            // 判断额度
            let _ai = aiPoints, _aiStatus = aiUsageStatus;
            if (newSet?.new) {
                _ai = newSet.aiPoints;
                _aiStatus = newSet.aiUsageStatus;
            }
            let g_use = _ai.ai_points_gift_use;
            let g_all = _ai.ai_points_gift_all;
            let p_use = _ai.ai_points_paid_use;
            let p_all = _ai.ai_points_paid_all;
            if ((g_all - g_use < 20) && (p_all - p_use < 20)) {
                if (userLevel !== 1 && [30002, 30003, 40002].includes(_aiStatus)) {
                    if ([40002].includes(_aiStatus)) {
                        openUpdateLimit();
                    } else {
                        props.openOverageModal({ type: 'points', points: 20, onSuccess: () => getRecordData(true) });
                    }
                } else if (_aiStatus === true) {
                    handleOverchargeState(true, 20);
                } else if (userLevel === 3) {
                    handleBuyAiCreditsState(true);
                } else {
                    props.handleShowGetMoreUsageModal('ai', aiUse);
                }
            } else {
                setGenerateLoading(true);
                let params = {
                    keyword: _seedKeyword,
                    location_id: currents.id,
                    language: languageValue,
                }
                const res = await reqGenerateTopicCluster(params);
                if (res.ack === 1) {
                    setGStep(1);
                    getRecordData();
                } else {
                    setTipBanner(res.msg);
                }
                setGenerateLoading(false);
            }
        }
    }

    // 超额扣费（AI 积分直充：_aiStatus === true 场景）
    const handleOverchargeState = async (state, defalutPoints = 0) => {
        setAgreeLoading(true);
        let params = {
            points: defalutPoints > 0 ? defalutPoints : 20
        }
        const res = await reqHandleAIUsagePayment(params);
        if (res.ack === 1) {
            // 更新record
            getRecordData(true);
        } else {
            toggleToast(res.msg, true);
        }
        setAgreeLoading(false);
    }

    // 跳转详情
    const handleJumpPlannerDetail = (id, type = 0) => {
        props.history.push({
            pathname: `/content-seo/keyword-content-planner/detail`,
            search: `?tc_id=${id}&tc_type=${type}`,
        });
    }

    // 关键词改变
    const handleSeedKeywordChange = useCallback((value, level = 1) => {
        seedKeywordRef.current = value;
        setSeedKeyword(value);
        setSeedKeywordError(value?.length > 80 ? "The seed keyword cannot exceed 80 characters." : "");
        if (level !== 1) {
            setCustomSeedKeywordState(true);
            let isHasValue = Boolean(value.trim());
            setKeywordSugPop(isHasValue);
            if (!value) {
                setKeywordSugData([]);
            }
            if (value?.length <= 80 && isHasValue) {
                setKeywordSearchLoading(true);
                debouncedKeywordSearch(value);
            }
        }
    }, [])

    // 编辑
    const handleEditPlanName = (id, topic_cluster) => {
        // 切换输入框
        setEditPlanId(id);
        setTopicNameValue(topic_cluster);
    }

    // 编辑输入框内容
    const handleEditPlanNameChange = (value) => {
        setTopicNameValue(value);
    }
    // 编辑输入框失去焦点
    const handleBlurNameInput = async (id, topic_cluster) => {
        // 判断是否更新
        if (topicNameValue !== topic_cluster && topicNameValue !== "") {
            setSaveTopicNameLoading(true);
            const res = await reqUpdateTopicCluster({ id, topic_cluster: topicNameValue });
            if (res.ack === 1) {
                let cData = tableData.map(item => {
                    if (item.id === id) {
                        return { ...item, topic_cluster: topicNameValue };
                    }
                    return item;
                })
                setTableData(cData);
                setSaveTopicNameLoading(false);
                setEditPlanId(-1);
                getListData(pageRef.current, sizeRef.current, queryValue);
            } else {
                setTipBanner(res.msg);
            }
        } else {
            setEditPlanId(-1);
        }
    }

    // 切换页数
    const changePageSize = (s) => {
        pageRef.current = 1;
        sizeRef.current = s;
        setPage(1);
        setSize(s);
        setCurrentPageSize(s);
        getListData(1, s, queryValue);
    }

    // 分页 失去焦点
    const handlePageBlur = (e) => {
        pageRef.current = Number(e);
        setPage(Number(e));
        getListData(Number(e), sizeRef.current, queryValue);
    }

    // 分页
    const changePageTable = (p) => {
        pageRef.current = p;
        setPage(p);
        getListData(p, size, queryValue);
    }

    // 删除
    const handleDeletePlan = async () => {
        setDelBtnLoading(true);
        const res = await reqDeleteTopicCluster({ ids: operaId });
        if (res.ack === 1) {
            setDelTipState(false);
            let page = pageRef.current;
            let size = sizeRef.current;
            let query = queryValue;
            getListData(page, size, query);
            clearSelection();
            toggleToast(t("Delete successfully"));
        } else {
            setTipBanner(res.msg);
        }
        setDelBtnLoading(false);

    }

    // ai额度升级
    const aiUpgradeClick = () => {
        if (!isShowAiProgress) return;
        // 判断是否达到上限
        if (userLevel === 1) {
            if (aiUse === aiAll && aiUse !== 0) {
                props.handleShowGetMoreUsageModal('ai', aiUse);
            } else {
                props.upgradeModal(1, 'KeywordPlanner', 'keyword_content_planner');
            }
        } else {
            // 判断额度
            let _aiStatus = aiUsageStatus;
            if (_aiStatus !== true) {
                if ([30002, 30003, 40002].includes(_aiStatus)) {
                    if ([40002].includes(_aiStatus)) {
                        openUpdateLimit();
                    } else {
                        props.openOverageModal({ type: 'points', points: 20, onSuccess: () => getRecordData(true) });
                    }
                    progressAiOpenRef.current = true;
                } else if (userLevel === 3) {
                    handleBuyAiCreditsState(true);
                } else {
                    props.handleShowGetMoreUsageModal('ai', aiUse);
                }
            }
        }
    }

    // 选择自定义
    const handleSelectCustomValue = (type) => {
        if (type === "seedKeyword") {
            setCustomSeedKeywordState(false);
            if (keywordSugData.length === 0) {
                setKeywordSugPop(false);
            }
        }
    }

    // 设置关键词
    const handleSetSeedKeywordValue = (value) => {
        let _value = (value || "").trim();
        seedKeywordRef.current = _value;
        setSeedKeyword(_value);
        setSeedKeywordError(_value?.length > 80 ? "The seed keyword cannot exceed 80 characters." : "");
        setKeywordSugPop(false);
        setCustomSeedKeywordState(false);
    }

    // 聚焦搜索 
    const handleFocusSearch = () => {
        setIsShowClickTip(false);
        if (Boolean(seedKeyword) && keywordSugData.length > 1) {
            setKeywordSugPop(true);
        }
        setSeekIn(true);
        addListenKeyDown();
    }

    // 失去焦点搜索
    const onOutsideClick = () => {
        setNationState(false);
        setLanguageState(false);
        setKeywordSugPop(false);
        setSeekIn(false);
        setIsShowAudienceLocal(false);
    }

    // 最外层点击
    const handleOutPopAction = () => {
        setTimeout(() => {
            setIsShowAudienceLocal(true);
        }, 0);
    }

    // 品牌名称改变
    const handleBrandNameChange = (value) => {
        setBrandNameValue(value);
    }

    // 显示企业信息配置
    const handleShowBusinessInfoSet = () => {
        if (!abusinLoading && !manualAnalyzeLoading && !reduxLoading) {
            if (isShowAdjustPop) {
                props.requestStateSet('in_business', 1);
            }
            setIsShowAdjustPop(false);
            setBusinessInfoSetState(true);
            handleGetKeywordSuggestions();
        }
    }

    // 设置主要产品
    const setChangeTagsData = (data, type) => {
        let value = data.map(item => item.value);
        if (type === "PrimaryProduct") {
            setPrimaryProduct(value);
        } else if (type === "KeyProductAttributes") {
            setKeyProductAttributes(value);
        } else if (type === "TargetPersona") {
            setTargetPersona(value);
        }
    }

    // 关闭步骤
    const handleCloseSteps = () => {
        setStepsStorageState(false);
        try {
            sessionStorage.setItem('stepsStateKeyword', 'close');
        } catch (e) { }
    }

    // // 关闭提示弹窗
    // const handleToggleTipPop = () => {
    //     setIsShowAdjustPop(false);
    //     props.requestStateSet('in_business', 1);
    // }

    // 重置
    const handleResetAll = () => {
        setIsResetAll(true);
        setGStep(0);
        setStepData([]);
        setErrorState(false);
        setGenerateLoading(false);
        setAgreeLoading(false);
        setSeedKeyword("");
        setSeedKeywordError("");
        setStartGFirst(0);
        setStartGSec(0);
        setStartGThird(0);
        setStartGFourth(0);
        setIsStartGenerate(false);
        isResetAllRef.current = true;
        topicDataRef.current = null;
        recordDataRef.current = null;
        recKeywordDataRef.current = null;
        analyzeBusinessDataRef.current = null;
        aiStepSettingRef.current = {};
        timeoutsRef.current = [];
        animationFrameRef.current = null;
        isJumpRef.current = true;
        prevTopicIdRef.current = -1;
        gStepRef.current = 0;
        isStartGenerateRef.current = false;
        moreRecordRef.current = 0;
        progressAiOpenRef.current = false;
        listeningRef.current = false;
        seedKeywordRef.current = "";

    }

    //点击联系客服
    const handleContactService = () => {
        try {
            showNewMessage()
        } catch (e) {
            props.toggleToast(t("Try again later"), true);
        }
    }

    // 获取网站同步状态
    const getWebsiteSyncStatus = async (type = 1) => {
        const res = await reqGetWebsiteSyncStatus();
        if (res.ack === 1) {
            setAiAnalysisStatus(res.data.ai_analysis);
            setAiKeywordStatus(res.data.ai_keyword);
            if (res.data.ai_analysis === 1 || res.data.ai_keyword === 1) {
                if (AnalysisStatusArr.length === 0) {
                    // 还未检测完成， 继续轮询
                    let timer = setInterval(() => {
                        getWebsiteSyncStatus(type);
                    }, 5000)
                    AnalysisStatusArr.push(timer);
                }
            } else {
                if (type === 1) {
                    // 请求数据
                    getAnalyzeBusinessData();
                }
                if (type === 2) {
                    // 获取推荐关键词
                    getRecommendKeywordsList();
                } else {
                    setLoadingRecKeyword(false);
                }
                // 清除网站同步状态定时器
                clearAnalysisStatusArr();
                // 清除假进度
                clearFakeTimers();
            }
        } else {
            toggleToast(res.msg, true);
        }
    }

    // 清除网站同步状态定时器
    const clearAnalysisStatusArr = () => {
        AnalysisStatusArr.map(timer => {
            clearInterval(timer);
            AnalysisStatusArr.pop();
            return false;
        })
    }

    // 启动假进度
    const startFakeProgress = () => {
        clearFakeTimers();
        fakeSteps.forEach(step => {
            const timerId = setTimeout(() => {
                // 如果已经完成，就不要再改值
                if (completedVal < 100) {
                    setCompletedVal(step.value);
                }
            }, step.delay);
            fakeTimers.push(timerId);
        });
    };

    // 清除假进度
    const clearFakeTimers = () => {
        fakeTimers.forEach(timer => clearTimeout(timer));
        fakeTimers = [];
    };

    // 手动分析
    const handleManualAnalyze = async () => {
        setManualAnalyzeLoading(true);
        const res = await reqTriggerAiAnalyzeBusiness();
        if (res.ack === 1) {
            // 请求数据
            setBusinessInfoSetState(true);
            getWebsiteSyncStatus(1);
            startFakeProgress();
        } else {
            toggleToast(res.msg, true);
        }
        setManualAnalyzeLoading(false);
    }

    // 获取关键词建议
    const handleGetKeywordSuggestions = () => {
        // 老用户需要手动触发
        if (aiAnalysisStatus === 0) {
            handleManualAnalyze();
        } else if (aiAnalysisStatus === 1) {
            // 打开弹窗
            setBusinessInfoSetState(true);
            // 轮询
            getWebsiteSyncStatus(1);
            // 启动假进度
            startFakeProgress();
        } else {
            // 打开弹窗
            setBusinessInfoSetState(true);
        }
    }

    // 切换关键词建议
    const handleChangeSuggestions = () => {
        // 判断是下一页还是上一页
        let _data = cloneDeep(allRecommendKeywordsList);
        let _page = (rpage * rsize < rtotal) ? rpage + 1 : 1;
        let _list = _data.slice((_page - 1) * rsize, _page * rsize);
        setRpage(_page);
        setRecommendKeywordsList(_list);
    }

    // 关闭企业信息配置弹窗
    const handleCloseBusinessModal = () => {
        setBusinessInfoSetState(false);
        // 恢复数据
        setBrandNameValue(originBusinessData.brand_name);
        setPrimaryProduct(originBusinessData.primary_products);
        setKeyProductAttributes(originBusinessData.key_attributes);
        setTargetPersona(originBusinessData.target_audience);
    }

    // 保存企业信息
    const handleSaveBusinessInfo = async () => {
        setSaveBusinessInfoLoading(true);
        const params = {
            brand_name: brandNameValue,
            content_language: languageValue,
            audience_location: currents.abb,
            primary_products: PrimaryProduct || [],
            key_attributes: KeyProductAttributes || [],
            target_audience: TargetPersona || [],
        }
        const res = await reqUpdAnalyzeBusiness(params);
        if (res.ack === 1) {
            setBusinessInfoSetState(false);
            getAnalyzeBusinessData();
            getWebsiteSyncStatus(2);
        } else {
            toggleToast(res.msg, true);
        }
        setSaveBusinessInfoLoading(false);
    }

    // 触发指导效果
    const triggerGuideEffect = (_state = true) => {
        setIsShowClickTip(_state);
    }

    // 移除关键词建议
    const handleRemoveSuggestion = async (e, id) => {
        e.stopPropagation();
        setRemoveLoadingId(id);
        const params = {
            id,
            type: "content_plan",
        }
        const res = await reqDelRecommendKeywords(params);
        if (res.ack === 1) {
            setRemoveLoadingId(-1);
            let newRecommendKeywordsList = cloneDeep(allRecommendKeywordsList).filter(item => item.id !== id);
            setAllRecommendKeywordsList(newRecommendKeywordsList);
            let _data = cloneDeep(newRecommendKeywordsList).slice((rpage - 1) * rsize, rpage * rsize);
            if (_data.length === 0 && rpage > 1) {
                let _ndata = cloneDeep(newRecommendKeywordsList).slice((rpage - 2) * rsize, (rpage - 1) * rsize);
                setRecommendKeywordsList(_ndata);
                setRpage(rpage - 1);
            } else {
                setRecommendKeywordsList(_data);
            }
            setHasNextChange(newRecommendKeywordsList.length > rsize);
            setRtotal(newRecommendKeywordsList.length);
        } else {
            toggleToast(res.msg, true);
        }
    }

    // 回车监听
    const keyEnterDown = useCallback((event) => {
        // 输入法组合输入中（如中文拼音选词），此时的回车用于上屏确认，不触发搜索
        if (event.isComposing || event.keyCode === 229) return;
        if (event.key === 'Enter' && !generateLoading && !agreeLoading && listeningRef.current) {
            handleGenerate({});
        }
    }, [generateLoading, agreeLoading, handleGenerate]);
    const addListenKeyDown = () => {
        listeningRef.current = true;
    };
    const removeListenKeyDown = () => {
        listeningRef.current = false;
    };

    useEffect(() => {
        document.addEventListener('keydown', keyEnterDown);
        return () => {
            document.removeEventListener('keydown', keyEnterDown);
        };
    }, [keyEnterDown]);

    // 针对列表数据变化情况筛选
    useEffect(() => {
        pageRef.current = page;
        sizeRef.current = size;
        clearSelection();
    }, [page, size, queryValue])

    useEffect(() => {
        setUserLevel(level);
    }, [level])

    useEffect(() => {
        let existBusiness = Boolean(PrimaryProduct?.length > 0 || KeyProductAttributes?.length > 0 || TargetPersona?.length > 0);
        setExistBusiness(existBusiness);
    }, [PrimaryProduct, KeyProductAttributes, TargetPersona])

    // 在组件卸载时清除定时器，防止内存泄漏
    useEffect(() => {
        return () => {
            debouncedGetListData.cancel();
        };
    }, [debouncedGetListData]);

    // 监听点击
    useEffect(() => {
        const handleGlobalClick = (e) => {
            const target = e.target;
            if (target.closest(".audience_local_box")) return;
            if (target.closest(".config_module_search")) return;
            if (target.closest(".ai_blog_topic_item")) return;
            if (target.closest(".custom_edit_item")) return;
            if (target.closest(".country_box") || target.closest(".language_box")) {
                handleOutPopAction();  // 点击国家或语言下拉框不执行外部事件
                return;
            }

            // 执行外部事件
            onOutsideClick?.();
        };
        // 捕获阶段
        document.addEventListener("click", handleGlobalClick, true);

        return () => {
            document.removeEventListener("click", handleGlobalClick, true);
        };
    }, [onOutsideClick]);

    useEffect(() => {
        eventBus.addEventListener(KeywordPlanner_CLICK, triggerGuideEffect)

        // 设置页面缓存
        const _reduxKCP = store.getState().page.pageInit.KeywordContentPlanner;
        topicDataRef.current = _reduxKCP.topicData;
        recordDataRef.current = _reduxKCP.recordData;
        recKeywordDataRef.current = _reduxKCP.recKeywordData;
        analyzeBusinessDataRef.current = _reduxKCP.analyzeBusinessData;

        const query = typeof props.location.query === 'string' ? props.location.query : "";
        seedKeywordRef.current = query;
        setSeedKeyword(query);
        // 设置国家信息
        setCountryAll(Countrys);
        setCountryView(Countrys.slice((cpage - 1) * csize, (cpage * csize)));
        setCountryLens(Countrys.length);
        // 浏览器缓存
        try {
            // 步骤状态
            let stepsState = sessionStorage.getItem('stepsStateKeyword');
            setStepsStorageState(!Boolean(stepsState));
        } catch (e) { }

        // 获取列表数据
        getListData(1, 10, "");
        // 获取生成记录
        getRecordData(false);
        // 请求数据
        getAnalyzeBusinessData();

        return () => {
            eventBus.removeEventListener(KeywordPlanner_CLICK, triggerGuideEffect)

            clearAllTimers();
            clearRecordTimer();
            clearAnalysisStatusArr();
            clearFakeTimers();
            isJumpRef.current = false;
        }
    }, []);

    // 视频弹窗
    const videoModal = <Modal title={t("From Keyword to Traffic: Build SEO Topical Clustering in Minutes-2025")}
        size="large"
        open={openVideo}
        onClose={() => {
            setOpenVideo(false);
        }}>
        <div className={'youtube-video-box'}>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/FnDwS_IYi4E?si=CRzxxcFrEI97rzAr" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
        </div>
    </Modal>

    // 分页
    const footerContentMsg = <FooterPageSelect
        page={page}
        current_PageSize={current_PageSize}
        total={total}
        changePageSize={changePageSize}
        handlePageBlur={handlePageBlur}
    />


    // 删除提示弹窗
    const deleteTipModal = <Modal
        size="small"
        open={delTipState}
        onClose={() => setDelTipState(false)}
        title={t("Delete this content plan?")}
        primaryAction={{
            content: t("Delete"),
            onAction: () => handleDeletePlan(),
            loading: delBtnLoading
        }}
        secondaryActions={[
            {
                content: t("Cancel"),
                onAction: () => setDelTipState(false)
            }
        ]}
    >
        <Modal.Section>
            <p>{t("This action cannot be undone.")}</p>
        </Modal.Section>
    </Modal>

    // 积分不足提示
    const creditsBuyModal = <Modal
        open={buyAiCreditsState}
        title={t("AI Credit Reminder")}
        primaryAction={{
            content: t("Purchase AI Credits"),
            onAction: () => props.history.push({
                pathname: "/plan",
                query: "pay_credits"
            })
        }}
        secondaryActions={[
            {
                content: t("Cancel"),
                onAction: () => handleBuyAiCreditsState(false)
            }
        ]}
        onClose={() => handleBuyAiCreditsState(false)}
    >
        <Modal.Section>
            <p>{t("Your AI credit balance is insufficient")}</p>
        </Modal.Section>
    </Modal>

    // Ai 额度模块
    const upgradeIcon = <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0ZM7.53027 2.96973C7.23738 2.67683 6.76262 2.67683 6.46973 2.96973L3.96973 5.46973C3.67683 5.76262 3.67683 6.23738 3.96973 6.53027C4.26262 6.82317 4.73738 6.82317 5.03027 6.53027L6.25 5.31055V10.5C6.25 10.9142 6.58579 11.25 7 11.25C7.41421 11.25 7.75 10.9142 7.75 10.5V5.31055L8.96973 6.53027C9.26262 6.82317 9.73738 6.82317 10.0303 6.53027C10.3232 6.23738 10.3232 5.76262 10.0303 5.46973L7.53027 2.96973Z" fill="var(--color-primary)" />
    </svg>
    const aiPerc = (aiUse / aiAll) > 1 ? 1 : (aiUse / aiAll);
    const AiProgressBlock = Boolean(isShowAiProgress || 1) && aiAll !== 0 ? <div className={`ai_progress_block ai_progress_block_tab ${aiPerc > 0.9 ? 'ProgressBarRed' : ''}`}>
        <p className='flex_layout progress_info'>
            <span>{t("AI credits")}: {aiUse}/{aiAll}</span>
            {isShowAiProgress ? <span className='upgrade_icon' onClick={aiUpgradeClick}>{upgradeIcon}</span> : null}
        </p>
        <ProgressBar animated={false} progress={Number((aiPerc * 100).toFixed(0))} size="small" />
    </div> : null

    // 企业信息配置
    const businessInfoSetModal = <Modal
        open={businessInfoSetState}
        title={aiAnalysisStatus === 2 ? t("Your business information") : t("Let's analyze your website...")}
        onClose={() => handleCloseBusinessModal()}
        primaryAction={{
            content: aiKeywordStatus !== 2 ? t("Get Keyword Suggestions") : t("Save"),
            onAction: () => handleSaveBusinessInfo(),
            loading: saveBusinessInfoLoading || aiAnalysisStatus === 1 || aiKeywordStatus === 1,
            disabled: !brandNameValue || aiAnalysisStatus === 1 || (!existBusiness && aiKeywordStatus !== 2),
        }}
        secondaryActions={[
            {
                content: t("Cancel"),
                onAction: () => handleCloseBusinessModal(),
                disabled: saveBusinessInfoLoading,
            }
        ]}
    >
        <Modal.Section>
            {
                aiAnalysisStatus === 2 ? <BlockStack gap={200}>
                    <Text variant="bodySm" as="p" tone="subdued">{t("This helps us generate content that fits your business and audience.")}</Text>
                    <div className={`business_step ai_business ${(aiAnalysisStatus === 2 && aiKeywordStatus === 0) ? 'purple_color_input' : ''}`}>
                        <BlockStack gap={400}>
                            <TextField
                                id="brandNameValue"
                                label={t("Brand Name")}
                                value={brandNameValue}
                                onChange={handleBrandNameChange}
                                autoComplete="off"
                                placeholder={t("Enter your brand name")}
                                error={!brandNameValue ? t("Brand name is required") : ""}
                            />
                            <div className='business_product'>
                                <span className='b_tag_title'>{t("Primary Product")}</span>
                                <TagTextInput
                                    id="PrimaryProduct"
                                    SelectCurrentItem={PrimaryProduct}
                                    setChangeTagsData={setChangeTagsData}
                                />
                            </div>
                            <div className='business_key_product_attributes'>
                                <span className='b_tag_title'>{t("Key Product Attributes")}</span>
                                <TagTextInput
                                    id="KeyProductAttributes"
                                    SelectCurrentItem={KeyProductAttributes}
                                    setChangeTagsData={setChangeTagsData}
                                />
                            </div>
                            <div className='business_target_persona'>
                                <span className='b_tag_title'>{t("Target Persona")}</span>
                                <TagTextInput
                                    id="TargetPersona"
                                    SelectCurrentItem={TargetPersona}
                                    setChangeTagsData={setChangeTagsData}
                                />
                            </div>
                        </BlockStack>
                    </div>
                </BlockStack> : <div className="ai_sync_animate">
                    <div className='animate_analyze_sync'>
                        <img className='ranks_first' src='/imgs/user_guide/ranks-1.png' alt='' />
                        <img className='ranks_sec' src='/imgs/user_guide/ranks-2.png' alt='' />
                    </div>
                    <div className='progress_bar_item'>
                        <ProgressBar progress={completedVal} size='small' tone='primary' />
                        <p>{t("Completed")} <span style={{ color: '#616161' }}>{completedVal}%</span></p>
                    </div>
                </div>
            }
        </Modal.Section>
    </Modal>

    // 配置模块
    const isDisableGenerate = !Boolean((seedKeyword || "")?.trim()) || Boolean((seedKeyword || "")?.length > 80) || generateLoading || loadingPage;
    const suggestionIcon = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_21112_89344)">
            <path d="M9.04529 5.81745C9.29207 5.09572 10.3122 5.09571 10.559 5.81745L11.4574 8.44831C11.5375 8.68264 11.7221 8.86632 11.9564 8.94636L14.5863 9.84479C15.3085 10.0914 15.3085 11.1128 14.5863 11.3594L11.9564 12.2579C11.7221 12.3379 11.5375 12.5216 11.4574 12.7559L10.559 15.3868C10.3122 16.1085 9.29208 16.1085 9.04529 15.3868L8.14686 12.7559C8.06674 12.5216 7.88221 12.3379 7.64783 12.2579L5.01795 11.3594C4.29577 11.1128 4.29577 10.0914 5.01795 9.84479L7.64783 8.94636C7.88221 8.86632 8.06674 8.68265 8.14686 8.44831L9.04529 5.81745ZM13.9183 4.4239C14.0099 4.15574 14.3893 4.15574 14.4808 4.4239L14.8148 5.40046C14.8446 5.48718 14.9127 5.55524 14.9994 5.58503L15.9769 5.91901C16.2446 6.01081 16.2447 6.38983 15.9769 6.48151L14.9994 6.81452C14.9125 6.84432 14.8445 6.91313 14.8148 7.00007L14.4808 7.97663C14.3892 8.2446 14.0099 8.24472 13.9183 7.97663L13.5853 7.00007C13.5556 6.91301 13.4868 6.84425 13.3998 6.81452L12.4232 6.48151C12.1553 6.38991 12.1554 6.01073 12.4232 5.91901L13.3998 5.58503C13.4868 5.55533 13.5555 5.48738 13.5853 5.40046L13.9183 4.4239Z" fill="#5B7CFF" />
        </g>
        <defs>
            <clipPath id="clip0_21112_89344">
                <rect width="20" height="20" rx="10" fill="white" />
            </clipPath>
        </defs>
    </svg>
    const configModule = gStep === 0 ? <Card>
        <div className="config_module">
            <div className="config_module_content">
                {/* 使用 */}
                <div className="config_how_use" onClick={() => setOpenVideo(true)}>
                    <Icon source={QuestionCircleIcon} />
                    <Text variant="bodyMd" as="p" tone="subdued">{t("How to use")}</Text>
                </div>

                {/* 头部区域 */}
                <div className="config_module_header_title">
                    <Text variant="heading2xl" as="h1" tone="magic">{t("AI Content Planner")}</Text>
                </div>

                <div className="config_module_tip">
                    <Text variant="bodyMd" as="p">
                        {t("Get high-potential content ideas based on your")} <span className="underline_text" onClick={handleShowBusinessInfoSet}>{t("business")}</span>.
                    </Text>
                    {
                        abusinLoading ? <div className="config_module_search_actions">
                            <Button loading={abusinLoading}>loading</Button>
                        </div> : <div className="config_module_search_actions">
                            {/* <Popover
                                active={isShowAdjustPop && !businessInfoSetState}
                                activator={
                                    (aiAnalysisStatus === 2 && aiKeywordStatus === 2 && existBusiness) ? <Button size="micro" icon={AdjustMinor} loading={aiKeywordStatus === 1} onClick={handleShowBusinessInfoSet}></Button> : <div></div>
                                }
                                onClose={() => handleToggleTipPop()}
                            >
                                <div className="config_module_adjust_content">
                                    <div className="config_edit_header">
                                        <Text variant="headingMd" as="h2">{t("Tell us about your business")}</Text>
                                        <Button size="micro" icon={CancelMinor} variant="tertiary" onClick={() => handleToggleTipPop()}></Button>
                                    </div>
                                    <div className="config_edit_line"></div>
                                    <Text variant="bodyMd" as="p" tone="subdued">
                                        {t("This helps us generate content that fits your business and audience.")}
                                    </Text>
                                    <div className="config_tip_edit_btn">
                                        <Button variant="primary" disabled={manualAnalyzeLoading} onClick={handleShowBusinessInfoSet}>{t("Edit info")}</Button>
                                    </div>
                                </div>
                            </Popover> */}
                            {
                                (aiAnalysisStatus === 2 && aiKeywordStatus === 2) ? <Button disabled={reduxLoading} size="micro" icon={AdjustIcon} loading={aiKeywordStatus === 1} onClick={handleShowBusinessInfoSet}></Button> : null
                            }
                            {
                                Boolean(hasNextChange) ? <Button size="micro" icon={RefreshIcon} disabled={abusinLoading || reduxLoading} onClick={handleChangeSuggestions}>{t("Change suggestions")}</Button> : null
                            }
                            {
                                (aiAnalysisStatus !== 2 || aiKeywordStatus !== 2) && <Button size="micro" icon={MagicIcon} disabled={reduxLoading} loading={abusinLoading || aiAnalysisStatus === 1 || aiKeywordStatus === 1 || manualAnalyzeLoading} onClick={handleGetKeywordSuggestions}>{t("Get Keyword Suggestions")}</Button>
                            }
                        </div>
                    }
                </div>

                {/* 搜索区域 */}
                <div className="config_module_block">
                    {
                        Boolean(isShowClickTip) && <div className="config_module_bg" onClick={() => {
                            setIsShowClickTip(false);
                            handleFocusSearch();
                        }}></div>
                    }
                    <div className="config_module_search" onClick={() => setSeedFocusedState(true)}>
                        <div className="enter_module">
                            <TextField
                                id="seedKeyword"
                                value={seedKeyword}
                                onChange={(value) => handleSeedKeywordChange(value, userLevel)}
                                autoComplete="off"
                                placeholder={t("Enter a seed keyword")}
                                error={seedKeywordError ? t(seedKeywordError) : ""}
                                disabled={generateLoading || loadingPage || reduxLoading}
                                focused={seedFocusedState}
                                onFocus={() => handleFocusSearch()}
                                onBlur={() => removeListenKeyDown()}
                                connectedRight={
                                    (seekIn || seedKeyword) ? null : (generateLoading || agreeLoading || reduxLoading) ? <span className="config_module_search_icon">
                                        <Spinner size="small" />
                                    </span> : <Tooltip content={t("{{v1}} credits per generation", 20)}>
                                        <span className="config_module_search_icon" onClick={() => handleGenerate({})}>
                                            <svg className={`${!isDisableGenerate ? "enable_click" : "disable_click"}`} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="24" height="24" rx="12" />
                                                <path d="M12.0255 5.25098C12.0324 5.25121 12.0392 5.25153 12.046 5.25195C12.0847 5.25429 12.1224 5.2596 12.1593 5.26758C12.1926 5.2748 12.2247 5.28607 12.257 5.29785C12.2694 5.30242 12.2829 5.30437 12.295 5.30957C12.3141 5.31773 12.3312 5.33003 12.3497 5.33984C12.3735 5.35248 12.3979 5.36387 12.42 5.37891C12.4589 5.40522 12.496 5.43535 12.5304 5.46973L18.5304 11.4697C18.8232 11.7626 18.8232 12.2374 18.5304 12.5303C18.2375 12.8231 17.7627 12.8231 17.4698 12.5303L12.7501 7.81055V18C12.7501 18.4142 12.4143 18.7499 12.0001 18.75C11.5859 18.75 11.2501 18.4142 11.2501 18V7.81055L6.5304 12.5303C6.23752 12.8231 5.76275 12.8231 5.46985 12.5303C5.17696 12.2374 5.17696 11.7626 5.46985 11.4697L11.4698 5.46973L11.5265 5.41797C11.5356 5.41057 11.5455 5.40437 11.5548 5.39746C11.5724 5.38446 11.5908 5.37278 11.6095 5.36133C11.6321 5.3475 11.6552 5.33543 11.6788 5.32422C11.6974 5.31539 11.7161 5.30712 11.7355 5.2998C11.7631 5.28942 11.7911 5.28143 11.8195 5.27441C11.8395 5.26944 11.8593 5.26309 11.88 5.25977C11.8911 5.25799 11.9021 5.25616 11.9132 5.25488C11.9417 5.2516 11.9708 5.25 12.0001 5.25C12.0086 5.25 12.0171 5.25069 12.0255 5.25098Z" fill="white" />
                                            </svg>
                                        </span>
                                    </Tooltip>
                                }
                            />
                        </div>
                        <Popover
                            active={keywordSugPop && !Boolean(seedKeywordError)}
                            activator={
                                (seekIn || seedKeyword) ? <div className="config_setting">
                                    <Popover
                                        active={isShowAudienceLocal}
                                        activator={
                                            <div className="config_setting_item" onClick={() => setIsShowAudienceLocal(!isShowAudienceLocal)}>
                                                <Icon source={AdjustIcon} tone="base" />
                                                <Text variant="bodyMd" as="p" tone="subdued">{currents.name} · {languageLabel}</Text>
                                                <Icon source={ChevronDownIcon} tone="base" />
                                            </div>
                                        }
                                        fullWidth
                                        onClose={() => {
                                            setIsShowAudienceLocal(false)
                                        }}
                                    >
                                        <div className="audience_local_box">
                                            <Popover
                                                active={nationState}
                                                activator={
                                                    <div className="aud_select">
                                                        <Text variant="bodyMd" as="p" tone="subdued" fontWeight="semibold">{t("Audience location")}</Text>
                                                        <Button
                                                            disclosure
                                                            fullWidth
                                                            textAlign='left'
                                                            onClick={() => togglePopSelect('nationState')}
                                                        >
                                                            <p className='nation_set' title={currents.abb}>
                                                                <img src={currents.src} alt='' />
                                                                <span style={{ color: '#303030', fontWeight: 550 }}>{currents.name}</span>
                                                            </p>
                                                        </Button>
                                                    </div>
                                                }
                                                autofocusTarget="first-node"
                                                onClose={() => togglePopSelect('nationState')}
                                                preferredAlignment="left"
                                            >
                                                <div className='country_box'>
                                                    <TextField
                                                        id="countryValue"
                                                        value={countryValue}
                                                        onChange={handleInputChange}
                                                        autoComplete="off"
                                                        placeholder={t("Search")}
                                                        prefix={<Icon source={SearchIcon} />}
                                                        clearButton
                                                        onClearButtonClick={() => handleInputChange("", "countryValue")}
                                                    />
                                                    <div className='countrys_all'>
                                                        {
                                                            countryView.map(item => {
                                                                return <p key={item.abb} title={item.abb} onClick={() => selectCountryData(item)}>
                                                                    <img src={item.src} alt={item.abb} />
                                                                    <span>{item.name}</span>
                                                                </p>
                                                            })
                                                        }
                                                        {
                                                            countryLens > 20 && <Button variant='plain' onClick={getMoreCountry}>{t("View more")}</Button>
                                                        }
                                                    </div>
                                                </div>
                                            </Popover>
                                            <Popover
                                                active={languageState}
                                                activator={
                                                    <div className="aud_select">
                                                        <Text variant="bodyMd" as="p" tone="subdued" fontWeight="semibold">{t("Content language")}</Text>
                                                        <Button
                                                            disclosure
                                                            fullWidth
                                                            textAlign='left'
                                                            onClick={() => togglePopSelect('languageState')}
                                                        >
                                                            <p className='lang_set'>
                                                                <span className="flex_layout">
                                                                    <svg width="14" height="14" viewBox="3 3 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3ZM10 4.5C7.98377 4.5 6.22118 5.58524 5.26367 7.20312L7.2627 9.20215C7.73476 9.6743 8 10.3148 8 10.9824V11.5C8 11.7761 8.22386 12 8.5 12C9.60457 12 10.5 12.8954 10.5 14V15.4775C12.52 15.2955 14.2254 14.0213 15.0205 12.25H14C13.8011 12.25 13.6104 12.1709 13.4697 12.0303C13.3291 11.8896 13.25 11.6989 13.25 11.5V11C13.25 10.5858 12.9142 10.25 12.5 10.25H10C9.02787 10.25 8.25 9.45499 8.25 8.49414C8.25002 7.95427 8.4997 7.4392 8.93066 7.10645L9.39258 6.75C9.48896 6.6756 9.54587 6.56024 9.5459 6.43848V6.39746C9.54598 5.5133 10.1655 4.77417 10.9941 4.58984C10.6718 4.53102 10.3393 4.5 10 4.5ZM4.65137 8.71191C4.55227 9.12498 4.5 9.55654 4.5 10C4.5 12.6961 6.43989 14.9389 9 15.4092V14C8.99999 13.7239 8.77614 13.5 8.5 13.5C7.39543 13.5 6.5 12.6046 6.5 11.5V10.9824C6.5 10.7126 6.3929 10.4535 6.20215 10.2627L4.65137 8.71191ZM12.875 5.31055C12.5368 5.75696 12.0007 6.04492 11.3975 6.04492C11.2031 6.04506 11.046 6.20307 11.0459 6.39746V6.43848C11.0459 7.02486 10.7736 7.57809 10.3096 7.93652L9.84766 8.29395C9.78818 8.33986 9.75002 8.41439 9.75 8.49414C9.75 8.63787 9.86756 8.75 10 8.75H12.5C13.6581 8.75 14.612 9.62502 14.7363 10.75H15.4492C15.4827 10.5048 15.5 10.2544 15.5 10C15.5 8.01633 14.4497 6.27804 12.875 5.31055Z" fill="#4A4A4A" />
                                                                    </svg>
                                                                </span>
                                                                <span className="flex_layout" style={{ color: '#303030', fontWeight: 550 }}>{languageLabel}</span>
                                                            </p>
                                                        </Button>
                                                    </div>
                                                }
                                                autofocusTarget="first-node"
                                                onClose={() => togglePopSelect('languageState')}
                                                preferredAlignment="center"
                                            >
                                                <div className='language_box'>
                                                    {
                                                        newLangArr.map(item => {
                                                            return <p key={item.label} onClick={() => selectLanguageData(item)}>{item.label}</p>
                                                        })
                                                    }
                                                </div>
                                            </Popover>
                                        </div>
                                    </Popover>
                                    {
                                        (generateLoading || agreeLoading) ? <span className="config_module_search_icon">
                                            <Spinner size="small" />
                                        </span> : <Tooltip content={t("{{v1}} credits per generation", 20)}>
                                            <span className="config_module_search_icon" onClick={() => handleGenerate({})}>
                                                <svg className={`${!isDisableGenerate ? "enable_click" : "disable_click"}`} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect width="24" height="24" rx="12" />
                                                    <path d="M12.0255 5.25098C12.0324 5.25121 12.0392 5.25153 12.046 5.25195C12.0847 5.25429 12.1224 5.2596 12.1593 5.26758C12.1926 5.2748 12.2247 5.28607 12.257 5.29785C12.2694 5.30242 12.2829 5.30437 12.295 5.30957C12.3141 5.31773 12.3312 5.33003 12.3497 5.33984C12.3735 5.35248 12.3979 5.36387 12.42 5.37891C12.4589 5.40522 12.496 5.43535 12.5304 5.46973L18.5304 11.4697C18.8232 11.7626 18.8232 12.2374 18.5304 12.5303C18.2375 12.8231 17.7627 12.8231 17.4698 12.5303L12.7501 7.81055V18C12.7501 18.4142 12.4143 18.7499 12.0001 18.75C11.5859 18.75 11.2501 18.4142 11.2501 18V7.81055L6.5304 12.5303C6.23752 12.8231 5.76275 12.8231 5.46985 12.5303C5.17696 12.2374 5.17696 11.7626 5.46985 11.4697L11.4698 5.46973L11.5265 5.41797C11.5356 5.41057 11.5455 5.40437 11.5548 5.39746C11.5724 5.38446 11.5908 5.37278 11.6095 5.36133C11.6321 5.3475 11.6552 5.33543 11.6788 5.32422C11.6974 5.31539 11.7161 5.30712 11.7355 5.2998C11.7631 5.28942 11.7911 5.28143 11.8195 5.27441C11.8395 5.26944 11.8593 5.26309 11.88 5.25977C11.8911 5.25799 11.9021 5.25616 11.9132 5.25488C11.9417 5.2516 11.9708 5.25 12.0001 5.25C12.0086 5.25 12.0171 5.25069 12.0255 5.25098Z" fill="white" />
                                                </svg>
                                            </span>
                                        </Tooltip>
                                    }
                                </div> : <div></div>
                            }
                            preferredAlignment='left'
                            autofocusTarget="none"
                            onClose={() => setKeywordSugPop(false)}
                            fullWidth
                        >
                            <div className='ai_keyword_suggestions_list'>
                                <BlockStack gap={200}>
                                    <div className='ai_blog_topic_data'>
                                        {
                                            keywordSearchLoading ? null : keywordSugData.map((item, index) => {
                                                return index === 0 ? <div key={`${item.keyword}-${index}`} className='ai_blog_topic_title Every_Card_Desc'>
                                                    <p>{t("Keyword")}</p>
                                                    <p>{t("Competition")}</p>
                                                    <p>{t("Volume")}</p>
                                                </div> : <div key={`${item.keyword}-${index}`} className='ai_blog_topic_item' onClick={() => handleSetSeedKeywordValue(item.keyword)}>
                                                    <p>{item.keyword}</p>
                                                    <p>
                                                        {
                                                            (item.competition && ["HIGH", "MEDIUM", "LOW"].includes(item.competition)) ? <Badge tone={item.competition === "HIGH" ? "warning" : item.competition === "MEDIUM" ? "attention" : "success"}>{t(`${item.competition === "HIGH" ? "High" : item.competition === "MEDIUM" ? "Medium" : "Low"}`)}</Badge> : '-'
                                                        }
                                                    </p>
                                                    <p>{item.volume ? numToUnit(item.volume) : '-'}</p>
                                                </div>
                                            })
                                        }
                                        {
                                            keywordSearchLoading ? <div key={`top_tab_keywordcontentplanner`} className='ai_blog_topic_title Every_Card_Desc'>
                                                <p>{t("Keyword")}</p>
                                                <p>{t("Competition")}</p>
                                                <p>{t("Volume")}</p>
                                            </div> : keywordSugData.length <= 1 && <div className='empty_data'><Badge>{t("No data")}</Badge></div>
                                        }
                                    </div>
                                    {
                                        (customSeedKeywordState && seedKeyword) ? <div className='custom_edit_item' onClick={() => handleSelectCustomValue("seedKeyword")}>
                                            <p style={{ color: '#000' }}>{t("Add")}:&nbsp;&nbsp;<span style={{ color: '#303030' }}>"{seedKeyword}"</span></p>
                                        </div> : null
                                    }
                                </BlockStack>
                            </div>
                        </Popover>
                    </div>
                </div>
            </div>

            {/* 建议区域 */}
            <div className="config_module_suggestions_list">
                {
                    recommendKeywordsList.map(item => {
                        return (
                            <div
                                key={item.id}
                                className={`suggestion_list`}
                                onClick={() => handleSetSeedKeywordValue(item.keyword)}
                            >
                                <div className="suggestion_list_info">
                                    <span>{suggestionIcon}</span>
                                    <span className="s_title">{item.keyword}</span>
                                </div>
                                <div className="suggestion_list_data">
                                    <span>{t("Competition")}: {t(item.competition)}</span>
                                    <span>{t("Volume")}: {item.volume ? numToUnit(item.volume) : '-'}</span>
                                </div>
                                <div className="suggestion_list_actions" style={removeLoadingId === item.id ? { opacity: 1 } : {}}>
                                    <Button variant="tertiary" icon={XIcon} disabled={removeLoadingId !== -1} loading={removeLoadingId === item.id} onClick={(e) => handleRemoveSuggestion(e, item.id)}></Button>
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        </div>
    </Card> : null

    {/* 步骤卡片区域 */ }
    const stepsModule = Boolean(isShowSteps && stepsStorageState) && <Card padding={0}>
        <div className="config_module_steps_content">
            <div className="config_module_steps_header">
                <Text variant="headingMd" as="h2">{t("How AI Content Planner works")}</Text>
                <Button icon={XIcon} variant="tertiary" onClick={handleCloseSteps}></Button>
            </div>
            <div className="config_module_steps">
                {
                    stepTipArr.map((item) => {
                        return (
                            <div className="step_card" key={item.id}>
                                <div className="step_card_image">
                                    <img src={item.img} alt="" />
                                </div>
                                <div className="step_card_content">
                                    <Text variant="headingMd" as="h3" tone="magic">{t("Step {{v1}}", item.id)}</Text>
                                    <Text variant="bodyMd" as="p">{t(item.desc)}</Text>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    </Card>

    // ai内容生成模块
    const aiContentGenerateModule = gStep > 0 ? <div className="ai_content_generate_module">
        <Card>
            <div className='generate_progress'>
                <div className='generate_progress_bar'>
                    <div className={`generate_progress_bar_finished ${gStep > 1 ? 'finished_pro' : ''}`} style={{ width: `${(gStep >= 1 && isStartGenerate) ? 100 : startGFirst}%` }}></div>
                </div>
                <div className='generate_progress_bar'>
                    <div className={`generate_progress_bar_finished ${gStep > 2 ? 'finished_pro' : ''}`} style={{ width: `${gStep >= 2 ? 100 : startGSec}%` }}></div>
                </div>
                <div className='generate_progress_bar'>
                    <div className={`generate_progress_bar_finished ${gStep > 3 ? 'finished_pro' : ''}`} style={{ width: `${gStep >= 3 ? 100 : startGThird}%` }}></div>
                </div>
                <div className='generate_progress_bar'>
                    <div className={`generate_progress_bar_finished`} style={{ width: `${gStep >= 4 ? 100 : startGFourth}%` }}></div>
                </div>
            </div>
            <div className='generate_all'>
                <div className={`generate_all_left`}>
                    <img className={`search_gif`} src={`${errorState ? '/imgs/ai/start_over.png' : '/imgs/ai/search_will.gif'}`} alt='' />
                </div>
                {
                    errorState ? <div className='generate_all_right'>
                        <div className="error_state_title">
                            <span className="error_state_title_icon">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10 6C10.4142 6.00001 10.75 6.3358 10.75 6.75001L10.7499 10.25C10.7499 10.6642 10.4141 11 9.99993 11C9.58572 11 9.24994 10.6642 9.24994 10.25L9.25 6.74999C9.25001 6.33577 9.5858 5.99999 10 6Z" fill="#303030" />
                                    <path d="M11 13C11 13.5523 10.5523 14 10 14C9.44772 14 9 13.5523 9 13C9 12.4477 9.44772 12 10 12C10.5523 12 11 12.4477 11 13Z" fill="#303030" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10ZM15.5 10C15.5 13.0376 13.0376 15.5 10 15.5C6.96243 15.5 4.5 13.0376 4.5 10C4.5 6.96243 6.96243 4.5 10 4.5C13.0376 4.5 15.5 6.96243 15.5 10Z" fill="#303030" />
                                </svg>
                            </span>
                            <Text variant="bodyMd" as="p">{t("Generation failed.")}</Text>
                        </div>
                        <div className="error_state_content">
                            <Text variant="bodyMd" as="p" tone="subdued">{t("Please try again or try a different keyword")}</Text>
                            <div className="error_state_buttons">
                                <Button onClick={handleContactService}>{t("Contact us")}</Button>
                                <Button variant="primary" onClick={handleResetAll}>{t("Start over")}</Button>
                            </div>
                        </div>
                    </div> : <div className='generate_all_right'>
                        <div className='generate_progress_title flex_layout'>
                            <span className='flex_layout'>
                                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.7803 9.03033C14.0732 8.73744 14.0732 8.26256 13.7803 7.96967C13.4874 7.67678 13.0126 7.67678 12.7197 7.96967L9.75 10.9393L8.53033 9.71967C8.23744 9.42678 7.76256 9.42678 7.46967 9.71967C7.17678 10.0126 7.17678 10.4874 7.46967 10.7803L9.21967 12.5303C9.51256 12.8232 9.98744 12.8232 10.2803 12.5303L13.7803 9.03033Z" fill="#303030" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M17.5 10C17.5 13.866 14.366 17 10.5 17C6.63401 17 3.5 13.866 3.5 10C3.5 6.13401 6.63401 3 10.5 3C14.366 3 17.5 6.13401 17.5 10ZM16 10C16 13.0376 13.5376 15.5 10.5 15.5C7.46243 15.5 5 13.0376 5 10C5 6.96243 7.46243 4.5 10.5 4.5C13.5376 4.5 16 6.96243 16 10Z" fill="#303030" />
                                </svg>
                            </span>
                            <Text variant="bodyMd" as="p">{gStep}/{4} {t(
                                gStep === 1 ? "Analyze SERP for seed keyword" :
                                    gStep === 2 ? "Collect Synonyms" :
                                        gStep === 3 ? "Analyze and Prioritize Keywords" :
                                            "Generate Topic Clusters"
                            )}</Text>
                        </div>
                        {
                            gStep === 1 ? <div className='generate_result generate_all_right_step1'>
                                {
                                    isStartGenerate && <AIOutputStream id="gstep_first_box" key="gstep_first" customClass='Every_Card_Title' contentSegments={stepData[1]?.data || []} onEnd={onEndAi} />
                                }
                            </div> : gStep === 2 ? <div className='generate_result generate_all_right_step2'>
                                <AIOutputStream id="gstep_sec_box" key="gstep_sec" customClass='content_text Every_Card_Desc' wordText={seedKeyword} wordNum={stepData[2]?.data?.length} contentSegments={[
                                    t("Search for words and subtopics related to the seed keyword.")
                                ]} onEnd={onEndAi} />
                            </div> : gStep === 3 ? <div className='generate_result generate_all_right_step3'>
                                <AIOutputStream id="gstep_third_box" key="gstep_third" customClass='content_text Every_Card_Desc' contentSegments={[
                                    t("Clean and prioritize keywords based on relevance and performance")
                                ]} onEnd={onEndAi} />
                            </div> : gStep === 4 ? <div className='generate_result generate_all_right_step4'>
                                <AIOutputStream id="gstep_fourth_box" key="gstep_fourth" customClass='content_text Every_Card_Desc' contentSegments={[
                                    t("Group keywords into themes and outline pillar & sub-page structures")
                                ]} onEnd={onEndAi} />
                            </div> : null
                        }
                    </div>
                }
            </div>

        </Card>
    </div> : null

    // 表格
    const rowMarkup = tableData.map(
        (
            { id, topic_cluster, type, updated_at },
            index,
        ) => (
            <IndexTable.Row
                id={id}
                key={id}
                selected={selectedResources.includes(id)}
                position={index}
                onClick={() => {
                    handleJumpPlannerDetail(id, type);
                }}
            >
                <IndexTable.Cell>
                    <div className="flex_layout topic_cluster_name">
                        {
                            editPlanId === id ? <div onClick={(e) => {
                                e && e.stopPropagation();
                            }}>
                                <TextField
                                    disabled={saveTopicNameLoading}
                                    loading={saveTopicNameLoading}
                                    value={topicNameValue}
                                    focused={true}
                                    onChange={handleEditPlanNameChange}
                                    onBlur={() => handleBlurNameInput(id, topic_cluster)}
                                    error={!Boolean(topicNameValue) ? t("The input cannot be empty!") : ""}
                                />
                            </div> : <Text variant="bodyMd" fontWeight="bold" as="span">
                                {topic_cluster}
                            </Text>
                        }
                        {Boolean(type === 1) && <Badge tone="success">{t("Sample")}</Badge>}
                        <div className="hover_btn">
                            <Button icon={EditIcon} size="micro" variant="tertiary" onClick={(e) => {
                                e && e.stopPropagation();
                                handleEditPlanName(id, topic_cluster)
                            }}></Button>
                        </div>
                    </div>
                </IndexTable.Cell>
                <IndexTable.Cell>{formatTimestamp(updated_at * 1000, true)}</IndexTable.Cell>
                <IndexTable.Cell>
                    <div className="hover_btn">
                        <Button icon={DeleteIcon} size="micro" variant="tertiary" onClick={(e) => {
                            e && e.stopPropagation();
                            handleOpenDelTip(id)
                        }}></Button>
                    </div>
                </IndexTable.Cell>
            </IndexTable.Row>
        ),
    );
    const tableModule = (total > 0 || (total === 0 && queryValueGet)) && <div className="content_planner_list">
        <Card padding={0}>
            <IndexFilters
                sortOptions={null}
                sortSelected={sortSelected}
                queryValue={queryValue}
                queryPlaceholder={t("Search keywords")}
                onQueryChange={handleFiltersQueryChange}
                onQueryClear={() => handleFiltersQueryChange('')}
                onSort={setSortSelected}
                primaryAction={false}
                cancelAction={{
                    onAction: onHandleCancel,
                    disabled: false,
                    loading: false,
                }}
                tabs={[
                    {
                        id: "All Topic Clusters",
                        content: t("All Topic Clusters"),
                    }
                ]}
                selected={selected}
                onSelect={setSelected}
                canCreateNewView={false}
                onCreateNewView={onCreateNewView}
                filters={[]}
                hideFilters={true}
                appliedFilters={[]}
                filteringAccessibilityTooltip={`${t("Search (F)")}`}
                onClearAll={handleFiltersClearAll}
                mode={mode}
                setMode={setMode}
            />
            <IndexTable
                loading={tableLoading || loadingPage}
                resourceName={{
                    singular: t("data"),
                    plural: t("data"),
                }}
                itemCount={tableData.length}
                selectedItemsCount={
                    allResourcesSelected ? 'All' : selectedResources.length
                }
                onSelectionChange={handleSelectionChange}
                headings={[
                    { title: t("Content Plan List") },
                    { title: t("Last update time") },
                    { title: "" },
                ]}
                promotedBulkActions={[
                    {
                        content: t("Delete"),
                        onAction: () => handleOpenDelTip(-1)
                    }
                ]}
            >
                {rowMarkup}
            </IndexTable>
            {
                Boolean(tableData.length > 0) && <div className={`justify_center ${current_PageSize > 5 ? 'sticky_footer' : ''}`}>
                    <Pagination
                        label={footerContentMsg}
                        hasPrevious={hasPrevious}
                        onPrevious={() => changePageTable(page - 1)}
                        hasNext={hasNext}
                        onNext={() => changePageTable(page + 1)}
                    />
                </div>
            }
        </Card>
    </div>

    // 底部
    const FooterHelpBox = <FooterTrustHelp />

    // 最终内容
    const pageMain = (loadingPage || loadingRecord || loadingRecKeyword) ? <SkeltonLoading /> : <Page>
        {AiProgressBlock}
        <BlockStack gap={400}>
            <BannerMsgMoudle MessageInfo={messageInfo} toggleToast={toggleToast} callbackCloseBanner={() => setMessageInfo({})} />
            {/* {generateModule} */}
            {configModule}
            {businessInfoSetModal}
            {aiContentGenerateModule}
            {tableModule}
            {stepsModule}
        </BlockStack>
        {FooterHelpBox}
    </Page>


    return (
        <div className="keyword_content_planner_pages">
            <title>SEOWILL - Keyword Content Planner</title>

            {pageMain}
            {deleteTipModal}
            {videoModal}
            {creditsBuyModal}
        </div>
    );
};

// 时间格式
function formatTimestamp(timestamp, isYear = false) {
    const now = new Date();
    const date = new Date(timestamp);
    const timeDiff = (now - date) / 1000; // 计算时间差（秒）
    const minutesDiff = Math.floor(timeDiff / 60);
    const hoursDiff = Math.floor(timeDiff / 3600);
    // 如果时间差小于1小时，返回"xx minutes ago"
    if (hoursDiff < 1) {
        return minutesDiff <= 0 ? 'just now' : `${minutesDiff} minutes ago`;
    }
    // 如果时间大于1小时，返回日期和时间
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12 || 12; // 转换为12小时制
    let timeText = isYear ? `${t(month)} ${day}, ${year} ${hours}:${minutes} ${ampm}` : `${t(month)} ${day} at ${hours}:${minutes} ${ampm}`;
    return timeText;
}

// 数字转换单位k
function numToUnit(num) {
    num = Number(num);
    return num > 999 ? (num / 1000).toFixed(1) + 'k' : num;
}

export default withRouter(KeywordContentPlaner);